import React, { Component } from 'react'
import { observer } from 'mobx-react';
import { Button, Icon, Input, message } from 'utils/ui';
import ModalShell from '../common/ModalShell';
import { createGroup } from '../api_calls/user';
@observer(["UserStore", "AuthStore", "FamilyStore"])
class CreateGroup extends Component {

    constructor(props) {
        super(props);
        this.state = { modalOpen: false, name: "", submittingNewGroup: false }
        this.buttonClicked = this.buttonClicked.bind(this);
        this.submitGroupClicked = this.submitGroupClicked.bind(this);
    }

    submitGroupClicked() {
        const { AuthStore } = this.props;
        const groupName = (this.state.name || "").trim();

        if (!groupName) {
            message.warn("Please enter a group name.");
            return;
        }

        if (this.state.submittingNewGroup) {
            return;
        }

        this.setState({ submittingNewGroup: true });
        let self = this;
        createGroup(groupName, [this.props.UserStore.user._id], this.props.UserStore.user._id, AuthStore.userAuth.auth.accessToken).then((res) => {
            if (res && res.success) {
                self.setState({ modalOpen: false, name: "", submittingNewGroup: false });
                self.props.UserStore.refreshGroups(this.props.UserStore.user._id, this.props.FamilyStore.activeGroupId);
                message.info("Next: click Add Group Member to copy and share your invite link.");
                return;
            }

            self.setState({ submittingNewGroup: false });
        });
    }

    buttonClicked() {
        if (this.props.UserStore.childViewActive) {
            message.warn("Cannot create a group as a child account");
        } else {
            this.setState({ modalOpen: true });
        }
    }

    closeModal() {
        this.setState({ modalOpen: false });
    }

    render() {
        const { UserStore } = this.props;
        const menuButtonStyle = {
            border: 'none',
            textAlign: 'center',
            padding: '15px',
            cursor: 'pointer',
            backgroundColor: UserStore.theme().icons || "white",
            color: UserStore.theme().font2 || "black",
            borderRadius: '40px',
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px"
        };
        return (
            <div>
                <ModalShell
                    className="register-modal"
                    overlayClassName="register-modal-overlay"
                    isOpen={this.state.modalOpen}
                    onRequestClose={() => { (this.state.submittingNewGroup ? console.log("tried to close") : this.setState({ modalOpen: false })) }}>
                    <div className="ui-modal-surface-light">
                        <h1 className="AppFont ui-modal-form-title" style={{ color: '#333', fontSize: '24px' }}>Create a Group</h1>
                        <div className="ui-modal-stack">
                            <div>
                                <label className="ui-form-label" style={{ marginBottom: '8px' }}>Group Name</label>
                                <Input
                                    value={this.state.name}
                                    onChange={(e) => { this.setState({ name: e.target.value }) }}
                                    style={{ width: '100%' }}
                                />
                            </div>
                                            <div className="ui-modal-actions">
                                <Button
                                    className="AppFont btn-submit ui-btn-success"
                                    style={{
                                        padding: '0 20px',
                                        height: '40px',
                                        borderRadius: '4px',
                                        border: 'none'
                                    }}
                                    disabled={this.state.submittingNewGroup}
                                    onClick={this.submitGroupClicked}>
                                    {this.state.submittingNewGroup ? "Creating..." : "Submit"}
                                </Button>
                                <Button
                                    className="AppFont btn-cancel ui-btn-danger"
                                    style={{
                                        padding: '0 20px',
                                        height: '40px',
                                        borderRadius: '4px',
                                        border: 'none'
                                    }}
                                    onClick={this.closeModal.bind(this)}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalShell>

                
                <Button
                    className="add-group-button"
                    style={{
                        ...menuButtonStyle,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        color: '#fff',
                        cursor: 'pointer',
                        userSelect: 'none',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(74,144,226,0.2)'
                    }}
                    onClick={this.buttonClicked}
                    >
                    <Icon type="usergroup-add" /> Create Group
                </Button>
                
            </div>
        )
    }
}
export default CreateGroup;
